import { render, staticRenderFns } from "./compUserStats.vue?vue&type=template&id=f7c0dd90&"
import script from "./compUserStats.vue?vue&type=script&lang=js&"
export * from "./compUserStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports